import { Platform, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText, Button, LoadingDots } from '@garnish/core';

export const OrderPlaybackFooter = (props: OrderPlaybackFooterProps) => {
  const { isLoading, title, cta, onPressCta } = props;

  return (
    <View style={[styles.container, padding]}>
      <BodyText sizeMatch={['14']} style={styles.title}>
        {title}
      </BodyText>

      {isLoading ? (
        <View style={styles.loading}>
          <LoadingDots color={theme.colors.KALE} />
        </View>
      ) : (
        <Button size="small" palette="kale" accessibilityLabel={cta} onPress={onPressCta}>
          {cta}
        </Button>
      )}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing['6'],
    paddingHorizontal: theme.spacing['6'],
    gap: theme.spacing['2'],
    alignItems: 'center',
    justifyContent: 'center',
    borderTopWidth: 1,
    borderColor: theme.colors.LIGHT,
  },
  withPadding: {
    paddingBottom: theme.spacing['6'],
  },
  withoutPadding: {
    paddingBottom: 0,
  },
  loading: {
    height: 32,
  },
  title: {
    color: theme.colors.KALE,
  },
});

const padding = Platform.select({
  ios: styles.withoutPadding,
  default: styles.withPadding,
});

// ─── Types ───────────────────────────────────────────────────────────────────

type OrderPlaybackFooterProps = {
  isLoading: boolean;
  title: string;
  cta: string;
  onPressCta: () => void;
};
